import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const Navbar = () => {
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#030303]/70 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-2 group"
        >
          <div className="w-9 h-9 rounded-lg bg-neon grid place-items-center glow-pink group-hover:scale-105 transition-transform">
            <Zap className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display text-2xl font-black tracking-tighter">
            Boost<span className="text-gradient-neon">Up</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <a href="#pricing" data-testid="nav-pricing" className="hover:text-white transition">Pricing</a>
          <a href="#custom" data-testid="nav-custom" className="hover:text-white transition">Custom</a>
          <a href="#how" data-testid="nav-how" className="hover:text-white transition">How it works</a>
          <a href="#affiliate" data-testid="nav-affiliate" className="hover:text-white transition">Earn $$</a>
          <Link to="/reseller" data-testid="nav-reseller" className="hover:text-white transition">Reseller</Link>
          <a href="#faq" data-testid="nav-faq" className="hover:text-white transition">FAQ</a>
        </nav>
        <a
          href="#pricing"
          data-testid="nav-cta"
          className="bg-neon text-white font-bold text-sm px-5 py-2.5 rounded-full hover:scale-105 transition-transform glow-pink"
        >
          Get Followers
        </a>
      </div>
    </header>
  );
};

export default Navbar;
